export default "__VITE_ASSET__DkJLUhPC__"